<template>
  <div>
    <RouterView />
    
    <!-- Maintenance Modal - wird automatisch angezeigt wenn Wartungsarbeiten laufen -->
    <MaintenanceModal />

    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">
  </div>
</template>

<script>
import MaintenanceModal from './components/MaintenanceModal.vue'
import maintenanceService from './services/maintenanceService.js'

export default {
  name: 'App',
  components: {
    MaintenanceModal
  },
  mounted() {
    // Starte die periodische Überprüfung des Maintenance-Status
    maintenanceService.startPeriodicCheck()
    
    // HTTP Interceptor ist bereits automatisch aktiviert
    console.log('Maintenance system initialized')
  },
  beforeUnmount() {
    // Stoppe die periodische Überprüfung beim Beenden der App
    maintenanceService.stopPeriodicCheck()
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
